/**
 * 解析路由 meta.title：侧栏/面包屑等处勿直接 $t(中文)，否则易与嵌套文案冲突或 locale 键不一致触发 vue-i18n 警告。
 * 规则：先在各语言扁平 messages 上按 key 取字符串；带点路径再 $t；否则回退原文。
 */
export function resolveRouteTitle (vm, title) {
  if (title == null || title === '') return ''
  const key = String(title).trim()
  if (!key) return ''

  const i18n = vm.$i18n
  const messagesRoot = i18n.messages || {}
  const localeCandidates = []
  const push = (loc) => {
    if (loc != null && loc !== '' && localeCandidates.indexOf(loc) === -1) {
      localeCandidates.push(loc)
    }
  }
  push(i18n.locale)
  if (i18n.locale && String(i18n.locale).includes('-')) {
    push(String(i18n.locale).replace(/-/g, '_'))
  }
  if (i18n.locale && String(i18n.locale).includes('_')) {
    push(String(i18n.locale).replace(/_/g, '-'))
  }
  push('zh_CN')
  push('en')

  for (let i = 0; i < localeCandidates.length; i++) {
    const loc = localeCandidates[i]
    const pack = messagesRoot[loc]
    if (!pack || !Object.prototype.hasOwnProperty.call(pack, key)) continue
    const v = pack[key]
    if (typeof v === 'string') return v
  }

  if (key.indexOf('.') > -1) {
    const r = vm.$t(key)
    return typeof r === 'string' ? r : key
  }

  return key
}



// WEBPACK FOOTER //
// ./src/libs/i18n-route-title.js